import { Navigate, useLocation } from "react-router-dom";
import { useAuth, HOME_FOR } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function FullLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <Loader2 className="h-8 w-8 animate-spin text-[#003057]" />
    </div>
  );
}

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to={HOME_FOR[user.role] || "/"} replace />;
  return children;
}
